import CartToggle from '../cart/CartToggle.client';
import LanguageSelector from './LanguageSelector.client';
import type {LocalizedSlugs} from '../../types';
import {useEffect} from 'react';

type Props = {
  slugs?: LocalizedSlugs;
};

export default function HeaderActions({slugs}: Props) {
  return (
    <>
      <div className="flex h-full items-center gap-6 text-sm">
        {/* Language selector */}
        <div className="hidden md:block">
          <LanguageSelector slugs={slugs} />
        </div>
        {/* Cart */}
        <div className="flex h-full items-center justify-center">
          <CartToggle />
        </div>
      </div>
    </>
  );
}
